// extracted by mini-css-extract-plugin
export default {"tooltipEllipsis":"TooltipEllipsis-module__tooltipEllipsis___q9sm9","text":"TooltipEllipsis-module__text___mwsbK","tooltipOverflow":"TooltipEllipsis-module__tooltipOverflow___ucGo4"};